import { render, staticRenderFns } from "./WithdrawHistory.vue?vue&type=template&id=5de5acb4&scoped=true&"
import script from "./WithdrawHistory.vue?vue&type=script&lang=ts&"
export * from "./WithdrawHistory.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawHistory.vue?vue&type=style&index=0&id=5de5acb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de5acb4",
  null
  
)

export default component.exports